<div class="title">
  {{ '+GATEWAY_COMMISSIONING.TRANSFER_INSTALLATION.HEATING_TYPES.TITLE' | translate }}
</div>

<div
  class="full-width flex flex-row lt-md:flex-col gap-[24px] xs:gap-[16px] justify-start items-start"
>
  <div class="flex-[100%] max-w-[50%]">
    <div class="sub-title">
      {{ '+GATEWAY_COMMISSIONING.TRANSFER_INSTALLATION.HEATING_TYPES.DESCRIPTION' | translate }}
    </div>
    <div class="mandatory-description">
      <sup>*</sup>
      {{ '+GATEWAY_COMMISSIONING.TRANSFER_INSTALLATION.MANDATORY_FIELDS' | translate }}
    </div>
  </div>

  <div class="flex flex-col gap-[16px] flex-1">
    <div
      *ngFor="let heatingType of heatingTypes"
      class="heating-type-box flex flex-col gap-[16px] justify-center items-center"
      [class.selected]="selectedHeatingType === heatingType.type"
      (click)="onSelectHeatingType(heatingType.type)"
    >
      <img src="{{ heatingType.image }}" />

      <div class="flex flex-col gap-[16px] justify-start items-start">
        <div class="heating-type-title">{{ heatingType.title | translate }}</div>
        <div class="heating-type-description">{{ heatingType.description | translate }}</div>
        <div *ngIf="heatingType.tip" class="heating-type-tip">
          {{ heatingType.tip | translate }}
        </div>
        <app-banner>{{ heatingType.caution | translate }}</app-banner>
      </div>
    </div>
  </div>
</div>
